<template>
    <div class="card">
        <div>
          <div class="row">
            <div class="col-md-12">
            <table class="table custom-table-padding custome-table">
                <thead>			
                    <tr>
                        <th class="name-th">Test</th>
                        <th class="machine-th" v-if="hasMachineColumn">Machine Data</th>
                        <th :style="{ width: resultColumnWidth }" >Final Result</th>
                        <th v-if="hasUnitColumn">Unit</th>
                        <th v-if="hasInterpretationColumn">Reference</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(item, index) in tableItems.filter(
                          item => item.investigation_report_type != 'machine_image'
                        )" :key="item.id">
                        <td v-if="item.investigation_report_type !== 'general_text'">
                            {{ item.name }}
                        </td>
                        <td v-if="hasMachineColumn && item.investigation_report_type !== 'general_text'">
                          {{ item.machine_result }}
                        </td>
                        <td
                            v-bind:colspan="item.investigation_report_type === 'general_text' ?
                            (2 + (hasMachineColumn ? 1 : 0) + (hasUnitColumn ? 1 : 0) + (hasInterpretationColumn ? 1 : 0)) : 1"
                        >
                            <div v-if="item.investigation_report_type === 'general_text'" class="form-control">
                              <span>{{ item.name }}</span>
                              <AsyncSelect
                                  placeholder="Select"
                                  v-model="item.cs_growth"
                                  :api-service="fetchNoteMasterList"
                                  :additional-query="{note_type: item.note_master_type}"
                                  label="name"
                                  :reduce="option => option"
                                  class="mb-1"
                                  @update:modelValue="handleGrowthChange(item)"
                              />
                                <TipTapEditor
                                    v-model:content="item.result"
                                />
                            </div>
                            <v-select
                                v-else-if="item.investigation_report_type === 'antibiotics'"
                                class="form-control p-0"
                                v-model="item.result"
                                :options="antibioticsDrowdown"
                                label="name"
                                placeholder="Select antibiotic"
                                :reduce="name => name.id"
                            />
                          <AsyncSelect
                              placeholder="Select Result"
                              v-else-if="item.is_result_dropdown === 1"
                              v-model="item.result"
                              :api-service="fetchNoteMasterList"
                              :additional-query="{note_type: item.note_master_type}"
                              label="name"
                              :reduce="name => name.name"
                          />
                            <div v-else>
                                <vField
                                    rows="1" class="form-control"
                                    placeholder="Enter result"
                                    v-model="item.result"
                                    :name="`result_${item.id}`"
                                    @keydown.enter.prevent="focusNext(index)"
                                    :ref="el => inputRefs[index] = el"
                                />
                            </div>
                        </td>
                        <td v-if="item.investigation_report_type !== 'general_text' && hasUnitColumn">
                            {{ item.unit }}
                        </td>
                        <td v-if="item.investigation_report_type !== 'general_text' && hasInterpretationColumn">
                          <template v-if="item.investigation_report_type === 'antibiotics'">
                            <input type="text"
                                   class="form-control"
                                   v-model="item.comment"
                                   placeholder="Interpretation / Comment"
                            >
                          </template>

                          <template v-else>
                            {{ item.reference_value }}
                          </template>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
          </div>
        <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
</div>
</template>

<script setup>
import TipTapEditor from '@/components/atom/TipTapEditor';
import {computed, nextTick, ref, watch} from "vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleHospital from '@/services/modules/hospital';
import { getBase64ImageDataUri } from '@/services/utils/global.js';

const props = defineProps({
    tableItems: {
        type: Array,
    },
    antibioticsDrowdown: {
        type: Array,
    }
})

const { fetchNoteMasterList } = handleHospital();
const hasUnitColumn = computed(() => {
  return props.tableItems.some(
      item => item.unit !== null && item.unit !== ''
  )
})
const hasInterpretationColumn = computed(() => {
  return props.tableItems.some(item =>
      (item.investigation_report_type === 'antibiotics' &&
          item.comment !== null && item.comment !== '') ||
      (item.reference_value !== null && item.reference_value !== '')
  )
})

const handleGrowthChange = (item) => {
  item.result = '';
  if (
      item.cs_growth &&
      item.cs_growth.full_desc
  ) {
    item.result = item.cs_growth.full_desc;
  }

  if (
      !item.result &&
      item.cs_growth &&
      item.cs_growth.short_desc
  ) {
    item.result = item.cs_growth.short_desc;
  }
}

const hasMachineColumn = computed(() => {
  return props.tableItems.some(item => item.machine_result !== null && item.machine_result !== '');
});

const resultColumnWidth = computed(() => {
  return hasMachineColumn.value ? '40%' : '52%';
});

const inputRefs = ref([])

const focusNext = async (index) => {
  await nextTick()

  const nextInput = inputRefs.value[index + 1]

  if (nextInput) {
    nextInput.focus && nextInput.focus()
    nextInput.$el && nextInput.$el.focus()
  }
}

</script>

<style scoped>
.name-th{
    width: 25%;
}
.result-th{
    width: 40%;
}
.machine-th{
  width: 12%;
}
.custome-table tr {
  font-size: 12px;
  background-color: #00e7ff40;
}
</style>